import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { aftersales } from 'types/aftersales';

import AfterSalesMessage from './AfterSalesMessage';

const RefundMessage = ({
  afterSalesRules,
  isCancelOFEActive,
  canLookupRefundMessage,
  timezone,
  currency,
  canBeCancelled,
  refundableNCORules = false
}) => {
  if (canLookupRefundMessage) {
    const activeCancelRule = afterSalesRules
      .filter(({ type, override, active }) => type === aftersales.CANCEL && Boolean(isCancelOFEActive ? override : active))
      .reduce((rule, currentRule) => {
        if (!rule || (rule.active && rule.price === currentRule.price && rule.validUntil < currentRule.validUntil)) {
          return currentRule;
        }

        return rule;
      }, null);

    if (activeCancelRule) {
      return (
        <>
          <AfterSalesMessage rule={activeCancelRule} timezone={timezone} currency={currency} />
        </>
      );
    }
  }

  const message = `afterSalesRule.cancel.${canBeCancelled ? (refundableNCORules ? 'ncoUnavailable' : 'unavailable') : 'notCancellable'}`;

  return (
    <span>
      <FormattedMessage id={message} />
    </span>
  );
};

RefundMessage.propTypes = {
  timezone: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  canLookupRefundMessage: PropTypes.bool,
  isCancelOFEActive: PropTypes.bool,
  canBeCancelled: PropTypes.bool,
  afterSalesRules: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      validUntil: PropTypes.string.isRequired,
      currentActive: PropTypes.bool
    })
  ).isRequired,
  refundableNCORules: PropTypes.bool
};

export default RefundMessage;
